import { render, staticRenderFns } from "./GiftBoxIndex.vue?vue&type=template&id=f85a28ae&scoped=true&"
import script from "./GiftBoxIndex.vue?vue&type=script&lang=js&"
export * from "./GiftBoxIndex.vue?vue&type=script&lang=js&"
import style0 from "./GiftBoxIndex.vue?vue&type=style&index=0&id=f85a28ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85a28ae",
  null
  
)

export default component.exports